<div id="header-frame">
    <div>
        <h1>Barter Ledger Admin</h1>
    </div>

    <div>
        <app-component-user></app-component-user>
    </div>
</div>
